module.exports = __webpack_public_path__ + "media/illustrations/assignment_templates_nurture-eb52bb23.svg";